import { useSyncFiltersV2Meta } from "PFApp/components/filters_v2/hooks/use_sync_filters_v2_meta";
import { Meta } from "PFTypes";
import { useEffect } from "react";

export const useFiltersV2MetaAutoUpdate = (meta?: Partial<Meta>) => {
  const syncFiltersV2 = useSyncFiltersV2Meta();

  useEffect(
    () => {
      syncFiltersV2(meta);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [meta]
  );
};
